import { atom } from "recoil";

/**
 * <SplashScreen /> 에게 진행 중인 상태를 전달하기 위한 상태입니다.
 */
export const coldStartContextState = atom<string>({
  key: "coldStartContextState",
  default: "",
});
